import { FC, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { billingExplorerSetupVisualizationPropertyByKeySelector } from "@/store/dashboards/selectors/setups/billing-explorer/billingExplorerSetupVisualizationPropertyByKeySelector";
import { billingExplorerViewVisualizationChangeThunk } from "@/store/dashboards/thunks/widgets/billing-explorer-widget/setup-change/billingExplorerViewVisualizationChangeThunk";
import { SwitchWithTypography } from "@/components/SwitchWithTypography";

export const BillingExplorerWidgetVisualizationCumulativeLine: FC = () => {
  const dispatch = useAppDispatch();
  const cumulativeLine: boolean = !!useAppSelector(
    billingExplorerSetupVisualizationPropertyByKeySelector("cumulative_line"),
  );

  const changeHandler = useCallback(
    (checked: boolean) => {
      dispatch(
        billingExplorerViewVisualizationChangeThunk({
          cumulative_line: checked,
        }),
      );
    },
    [dispatch],
  );

  return (
    <SwitchWithTypography
      variant="filled"
      checked={cumulativeLine}
      onChange={changeHandler}
      title="Cumulative Line"
      infoTooltipTitle={infoTooltipTitle}
    />
  );
};

const infoTooltipTitle = "Show running totals over time.";
